const toKebabCase = (name) => name.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);

// Expõe colors.json como CSS custom properties (ex.: primaryLight -> --color-primary-light),
// para que os arquivos .css usem a mesma fonte de cores que o JS e o tema do antd.
export default function applyCssVariables(colors) {
  const root = document.documentElement;
  Object.entries(colors).forEach(([name, value]) => {
    root.style.setProperty(`--color-${toKebabCase(name)}`, value);
  });
}
